import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import WishlistPromoPopup from "./WishlistPromoPopup";
import WhatsAppFab from "./WhatsAppFab";

export default function Layout() {
    return (
        <div className="min-h-screen bg-[#050505] text-white flex flex-col">
            <Header />
            <main className="flex-1 pt-16">
                <Outlet />
            </main>
            <Footer />
            <CartDrawer />
            <WishlistPromoPopup />
            <WhatsAppFab />
        </div>
    );
}
